import React from "react";

/////////////////// LAZY LOAD ////////////////////////////
import Loadable from "react-loadable";
import Loading from "./common_components/Loading";

const AsyncMain = Loadable({
  loader: () => import("./tour_components/Main"),
  loading: Loading
});
//////////////////////////////////////////////////////////

export default class IgTour extends React.Component {
  render() {
    return <AsyncMain {...this.props} />;
  }
}
